import { Button as AntButton, Modal, Table, TableColumnsType } from "antd";
import { FC, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { getSurveyQuestion } from "../../../../api/surveyQuestion.api";
import useAxios from "../../../../hooks/useAxios";
import { IGetSurveyQuestion, ISurveyQuestionDetail } from "../../../../models/surveyQuestion.model";
import ErrorResponse from "../../../ErrorResponse";
import Loader from "../../../Loader";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  questionCode: number|undefined;
}

const SurveyAnswerModal: FC<IProps> = ({
  visible,
  setVisible,
  questionCode,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetSurveyQuestion>();

  useEffect(() => {
    if (questionCode) {
      execute(getSurveyQuestion(questionCode));
    }
  }, [questionCode]);

  const columns: TableColumnsType<ISurveyQuestionDetail> = [
    {
      title: t('homepage.survey.column11'),
      dataIndex: 'questionContent',
      key: 'questionContent',
    },
    {
      title: t('common.column.score'),
      dataIndex: 'score',
      key: 'score',
      align: 'center',
    },
  ];

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Modal
        title={t('homepage.survey.title8')}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setVisible(false)}
            >
              {t('common.button.close')}
            </AntButton>
          </div>
        ]}
      >
        <div className="text-center comm-table__area mt-0">
          {
            res?.data?.questionType === '01'
              ? (
                <Table
                  columns={columns}
                  dataSource={res?.data?.questionInfo}
                  pagination={{ pageSize: 99999 }}
                />
              )
              : <div className="nodata-text">{t('homepage.survey.text1')}</div>
          }
        </div>
      </Modal>
    </>
  );
}

export default SurveyAnswerModal;
